import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as Api from "@/api";
import Snackbar from "@/app/shared/Snackbar";
import { designTokens } from "@/design/style/theme";
import { setDialPbx } from "@/store/reducers/dial";

import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { type StoreState } from "../store";
import { type AuthStoreState } from "../types";
import Loading from "./Loading";
import Router from "./Router";

const App = () => {
  const dispatch = useDispatch();

  const [loadedAuthId, setLoadedAuthId] = useState<string | null>(null);

  const auth = useSelector<StoreState, AuthStoreState>((state) => state.auth);

  useEffect(() => {
    if (auth?.authenticated) {
      let cancelled = false;

      Promise.resolve(Api.getAccount({ id: auth.id }))
        .then((response) => {
          if (cancelled) return;

          if (response.data.account.partner) {
            Promise.resolve(Api.getPartner(response.data.account.partner)).then((response) => {
              if (cancelled) return;

              if (response.data.partner.defaultPbx) {
                dispatch(setDialPbx(response.data.partner.defaultPbx));
              }
            });
          }
        })
        .finally(() => {
          if (!cancelled) setLoadedAuthId(String(auth.id));
        });

      return () => {
        cancelled = true;
      };
    }
  }, [auth.authenticated, auth.id, dispatch]);

  const isLoading = auth.authenticated && loadedAuthId !== String(auth.id);

  return (
    <>
      <ThemeProvider theme={createTheme(designTokens)} noSsr defaultMode="system">
        <CssBaseline />
        <Snackbar />
        {isLoading ? <Loading /> : <Router />}
      </ThemeProvider>
    </>
  );
};

export default App;
